import { Outlet, useLocation } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import { FullPageSpinner } from '@/design-system/components/FullPageSpinner';
import { Toaster } from '@/design-system/components/Toast';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<FullPageSpinner />}>
        <Outlet />
      </Suspense>
      <Toaster />
    </>
  );
}
